/** Textes « filet » — le français fait foi. */
export const filet = {
  titre: "Cet écran n'a pas pu s'afficher",
  pasPerdues: 'Vos données ne sont pas perdues.',
  rienModifie: ` Rien n'a été modifié : cette erreur s'est produite en affichant la page, pas en enregistrant.`,
  continuer: `Vous pouvez continuer à travailler sur les autres écrans. Si le problème revient, signalez-le en indiquant sur quel écran vous étiez.`,
  revenir: "Revenir à Aujourd'hui",
  reessayer: 'Réessayer',
  detail: 'Détail technique',
};
